import LegalDisclaimerComponent from '@/components/pages/Terms/components/LegalDisclaimer'
import type { NextPage } from 'next'
import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

const LegalDisclaimer: NextPage = () => {
  return <LegalDisclaimerComponent />
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale as string, ['common'])),
    },
  }
}

export default LegalDisclaimer
